import { Button, Flex, Input, Switch, Tag, Typography } from "antd";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import useSWR from "swr";
import { API_URL, fetcher } from "../../../utils/fetcher";
import { useLocation } from "react-router-dom";
import { useUserFilesTabs } from "./UserFilesTabsContext";
import UserDetailsModal from "./user-details-modal";
import { SingleUserFileRoot } from "../../../types/SingleUserFileTypes";
import SessionReportModal from "./session-report-modal";
import GoalsInTheraphyModal from "./goals-in-theraphy-modal";
import SessionNotesModal from "./session-notes-modal";
import ConselorTakeAway from "./counselor-takeway-modal";
import SeniorconselorTakeAway from "./senior-counselor-takeway-modal";
import { Tooltip } from "antd";
import RedflagModal from "./redflag-modal";
import type { ColumnsType } from "antd/es/table";
import { SingleUserFileData } from "../../../types/SingleUserFileTypes";
import { useB2BContext } from "../../../context/ContextB2B";
import moment from "moment";
import AmberModal from "./ambar-modal";
import AmberModalTable from "./amber-modal_file";
import { articlesSVC } from "../../../services";
import { AppTable } from "../../../components/common";
type Props = {
  title: string;
  sessionType: "all" | "booking" | "tawk_chat";
};

const createColumns = (
  activeTab: string,
  handleSessionReportClick: (obj: any) => void,
  handleAmberClick: (obj: any) => void,
  handleTherapyGoalsClick: (obj: any) => void,
  handleSessionNotesClick: (obj: any) => void,
  handleCounselorTakeAwayClick: (obj: any) => void,
  handleSeniorCounselorClick: (obj: any) => void,
  searchText: string,
  getUserByID: any,
  isCounselor: boolean,
): ColumnsType<SingleUserFileData> => [
  {
    title: "Client ID",
    dataIndex: "clientId",
    key: "clientId",
    hidden: activeTab == "amber_records",
    render: (value: any) => value ?? "-",
  },
   {
  title: "Session Type",
  dataIndex: "sessionSource",
  key: "sessionSource",
  render: (value: string) =>
    value === "booking" ? <Tag color="blue">Counseling</Tag> : <Tag color="purple">Chat</Tag>,
},
  {
    title: "Client ID",
    dataIndex: "_id",
    key: "_id",
    hidden: activeTab !== "amber_records",
    render: (value: any) => value ?? "-",
  },
  {
    title: "Counselor",
    dataIndex: "requestedByName",
    key: "requestedByName",
    hidden: activeTab !== "amber_records",
    render: (value: string) => value ?? "-",
  },
  {
    title: "Counselor",
    dataIndex: "counselor",
    key: "counselor",
    hidden: activeTab == "amber_records",
    render: (value: string) => value ?? "-",
  },
  {
    title: "Session Time & Date",
    dataIndex:
      activeTab === "takeaway_resource"
        ? "sessionDateTime"
        : "sessionTimeAndDate",
    hidden: activeTab == "amber_records",
    key: "sessionDateTime",
    render: (value?: string): React.ReactNode =>
      value
        ? moment(value).local().format("DD MMM YYYY, hh:mm A") || value
        : "-",
  },
  {
    title: "Session Time & Date",
    dataIndex: "createdAt",
    key: "createdAt",
    hidden: activeTab !== "amber_records",
    render: (value?: string): React.ReactNode =>
      value ? moment(value).local().format("DD MMM YYYY, hh:mm A") : "-",
  },

  {
    title: "Approval Status",
    dataIndex: "approvalStatus",
    hidden: activeTab !== "takeaway_resource",
    key: "approvalStatus",
    render: (value: string) => value ?? "-",
  },
  {
    title: "Redflag Status",
    dataIndex: "redFlagStatus",
    key: "redFlagStatus",
    hidden: activeTab == "amber_records",
    render: (status?: boolean) => {
      return status === true ? <Tag color="red">Yes</Tag> : <Tag>No</Tag>;
    },
  },
  {
    title: "Approval Status",
    dataIndex: "ambarStatus",
    key: "ambarStatus",
    hidden: activeTab !== "amber_records",
    render: (status?: boolean) => {
      return status === true ? <Tag color="red">Yes</Tag> : <Tag>No</Tag>;
    },
  },
  {
    title: "Action",
    dataIndex: "user",
    key: "action",
    hidden: activeTab === "amber_records",
    render: (_, obj) =>
      activeTab === "session_report" ? (
        <Button
          className="table_pill_btn table_pill_btn--view"
          onClick={() => handleSessionReportClick(obj)}
        >
          {obj?.formData &&
          Object.values(obj?.formData).some((v) => v !== "" && v !== false)
            ? "View / Edit"
            : "Add"}
        </Button>
      ) : activeTab === "therapy_goals" ? (
        <Button
          className="table_pill_btn table_pill_btn--view"
          onClick={() => handleTherapyGoalsClick(obj)}
        >
          {Object.values(obj?.formData || {}).some(
            (v) => v !== "" && v !== false,
          )
            ? "View / Edit"
            : "Add"}
        </Button>
      ) : activeTab === "session_notes" ? (
        <Button
          className="table_pill_btn table_pill_btn--view"
          onClick={() => handleSessionNotesClick(obj)}
        >
          {obj?.formData &&
          Object.values(obj?.formData).some((v) => v !== "" && v !== false)
            ? "View / Edit"
            : "Add"}
        </Button>
      ) : (
        <>
          <Button
          className="table_pill_btn table_pill_btn--view"
            onClick={() =>
              isCounselor
                ? handleCounselorTakeAwayClick(obj)
                : handleSeniorCounselorClick(obj)
            }
          >
            {obj?.isTakeaway ? "View / Edit" : "Add"}
          </Button>
        </>
      ),
  },
  {
    title: "Action",
    dataIndex: "user",
    key: "action",
    hidden: activeTab !== "amber_records",
    render: (_, obj) => (
      <Button
          className="table_pill_btn table_pill_btn--view"
        onClick={() => handleAmberClick(obj)}
      >
        View
      </Button>
    ),
  },
];

function TabsTableInner({ title, sessionType }: Props) {
  const { getUserByID } = useB2BContext();
  const isCounselor = useMemo(() => {
    return getUserByID?.user_type === "Company_member"
      ? getUserByID?.roles?.includes("Counselor")
      : getUserByID?.user_type === "Counselor";
  }, [getUserByID]);
  const {
    activeTab,
    setUserDetailsModal,
    setRedflagModal,
    userDetails,
    redFlagChecked,
    setRedFlagChecked,
    setSessionReportModal,
    setGoalsInTheraphyModal,
    setSessionNotesModal,
    setCounselorTakeAwayModal,
    setSeniorcounselorTakeAwayModal,
    setSelectedModalObjReport,
    setSelectedModalObjGoals,
    setSelectedModalObj,
    setSelectedModalObjCounselor,
    setTakeAwayObj,
    setSeniocounselorObj,
    setAmberModal,
    amberModal,
    SetamberChecked,
    setAmberModalAlt,
    setSelectedModalObjamber,
  } = useUserFilesTabs();
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    setRedFlagChecked(userDetails?.redFlagStatus === "Yes");
  }, [userDetails?.redFlagStatus, setRedFlagChecked]);

  const { Text } = Typography;
  const location = useLocation();
  const clientId = location?.pathname.split("/")[3];

  const { data: sessionData, isLoading: sessionLoading } =
    useSWR<SingleUserFileRoot>(
      // activeTab === "takeaway_resource" ? `${API_URL}/sessionAction/takeaway/All`
      //   : `${API_URL}/sessionAction/session/${clientId}/${activeTab}`
      activeTab === "amber_records"
        ? `${API_URL}/session/ambar-history/${clientId}`
        : activeTab === "takeaway_resource"
          ? `${API_URL}/api/takeaway/${clientId}`
          : `${API_URL}/session/sessionAction/byUserId/${clientId}/${activeTab}`,
      fetcher,
      {
        revalidateOnFocus: false,
        revalidateOnReconnect: true,
        revalidateOnMount: true,
      },
    );

  const filteredData = useMemo(() => {
  let data = sessionData?.data || [];

  // Session Type Filter
  if (sessionType !== "all") {
    data = data.filter(
      (item: any) => item.sessionSource === sessionType
    );
  }

  // Search Filter
  if (!searchText) return data;

  const search = searchText.toLowerCase();

  return data.filter((record: any) => {
    const formattedDate = record.sessionDateTime
      ? moment(record.sessionDateTime)
          .format("DD/MM/YYYY")
          .toLowerCase()
      : "";

    return (
      record.clientId?.toString()?.toLowerCase()?.includes(search) ||
      record.counselor?.toLowerCase()?.includes(search) ||
      formattedDate.includes(search)
    );
  });
}, [sessionData?.data, searchText, sessionType]);

  // Memoize individual click handlers with useCallback
  const handleSessionReportClick = useCallback(
    (obj: any) => {
      setSelectedModalObjReport(obj);
      setSessionReportModal(true);
    },
    [setSelectedModalObjReport, setSessionReportModal],
  );

  const handleTherapyGoalsClick = useCallback(
    (obj: any) => {
      setSelectedModalObjGoals(obj);
      setGoalsInTheraphyModal(true);
    },
    [setSelectedModalObjGoals, setGoalsInTheraphyModal],
  );
  const handleAmberClick = useCallback(
    (obj: any) => {
      setSelectedModalObjamber(obj);
      setAmberModalAlt(true);
    },
    [setSelectedModalObjamber, setAmberModalAlt],
  );

  const handleSessionNotesClick = useCallback(
    (obj: any) => {
      setSelectedModalObj(obj);
      setSessionNotesModal(true);
    },
    [setSelectedModalObj, setSessionNotesModal],
  );

  const handleCounselorTakeAwayClick = useCallback(
    async (obj: any) => {
      // setSelectedModalObjCounselor(obj);
      // setCounselorTakeAwayModal(true);
      setTakeAwayObj(obj);
      try {
        setSelectedModalObjCounselor(null);
        if (obj?.isTakeaway) {
          const res = await articlesSVC.getSeniordetails(obj?.sessionId);
          setSelectedModalObjCounselor(res?.data?.data);
          setTakeAwayObj(obj);
        }
        setCounselorTakeAwayModal(true);
      } catch (error) {
        console.error("Error fetching senior counselor details:", error);
        setCounselorTakeAwayModal(true);
      }
    },
    [setSelectedModalObjCounselor, setCounselorTakeAwayModal, setTakeAwayObj],
  );

  const handleSeniorCounselorClick = useCallback(
    async (obj: any) => {
      try {
        setSeniocounselorObj(null);
        if (obj?.isTakeaway) {
          const res = await articlesSVC.getSeniordetails(obj?.sessionId);
          setSeniocounselorObj(res?.data?.data);
        }

        setSeniorcounselorTakeAwayModal(true);
      } catch (error) {
        console.error("Error fetching senior counselor details:", error);
        setSeniorcounselorTakeAwayModal(true);
      }
    },
    [setSeniocounselorObj, setSeniorcounselorTakeAwayModal],
  );

  const columns = useMemo(
    () =>
      createColumns(
        activeTab,
        handleSessionReportClick,
        handleAmberClick,
        handleTherapyGoalsClick,
        handleSessionNotesClick,
        handleCounselorTakeAwayClick,
        handleSeniorCounselorClick,
        searchText,
        getUserByID,
        isCounselor,
      ),
    [
      activeTab,
      handleSessionReportClick,
      handleTherapyGoalsClick,
      handleAmberClick,
      handleSessionNotesClick,
      handleCounselorTakeAwayClick,
      handleSeniorCounselorClick,
      searchText,
    ],
  );

  return (
    <Flex vertical gap={16} className="userFilesTables">
      <div className="filterMenu">
        <Text className="title24">{title}</Text>
        <div className="filterMenu__actions">
          <div className="redflag-wrapper">
            <Tooltip
              placement="bottom"
              overlayClassName="redflag-tooltip"
              title={
                <div className="redflag-popover">
                  <div className="notification-container">
                    <div className="notification-text">
                      <p>
                        <strong>🟡 Amber Notice: </strong> Activating the Amber
                        toggle will log your action and record the selected
                        reason in the system.
                      </p>
                      <p>
                        <strong>🔒 Internal Visibility:</strong> This record
                        will be visible to the Super Admin and Senior Counselor
                        for internal review. It will not be shared with the
                        client.
                      </p>
                      <p>
                        <strong>⚠️ Important: </strong> Please enable this only
                        when a follow-up or additional review may be beneficial.
                        Incorrect activation may result in unnecessary outreach.
                      </p>
                    </div>
                  </div>
                </div>
              }
            >
              <Flex align="center" gap={4} className="redflag-trigger">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20Z"
                    fill="#FFBF00"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13V8C11 7.73478 11.1054 7.48043 11.2929 7.29289C11.4804 7.10536 11.7348 7 12 7C12.2652 7 12.5196 7.10536 12.7071 7.29289C12.8946 7.48043 13 7.73478 13 8V13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14Z"
                    fill="#FFBF00"
                  />
                  <path
                    d="M11 16C11 15.7348 11.1054 15.4804 11.2929 15.2929C11.4804 15.1054 11.7348 15 12 15C12.2652 15 12.5196 15.1054 12.7071 15.2929C12.8946 15.4804 13 15.7348 13 16C13 16.2652 12.8946 16.5196 12.7071 16.7071C12.5196 16.8946 12.2652 17 12 17C11.7348 17 11.4804 16.8946 11.2929 16.7071C11.1054 16.5196 11 16.2652 11 16Z"
                    fill="#FFBF00"
                  />
                </svg>

                <Text className="redFlag">Amber</Text>
                <Switch
                  size="small"
                  className="redFlagSwitch"
                  checked={amberModal}
                  onChange={(checked) => {
                    SetamberChecked(checked);
                    if (checked) {
                      setAmberModal(true);
                    } else {
                      setAmberModal(false);
                    }
                  }}
                />
              </Flex>
            </Tooltip>
          </div>

          <div className="redflag-wrapper">
            <Tooltip
              placement="bottom"
              overlayClassName="redflag-tooltip"
              title={
                <div className="redflag-popover">
                  <div className="notification-container">
                    <div className="notification-text">
                      <p>
                        <strong>🚨 Caution:</strong> Activating the{" "}
                        <strong>Redflag</strong> toggle will log your action and
                        trigger an email notification with your MAC Address | IP
                        Address | Location
                      </p>
                      <p>
                        <strong>🔒 Security Notice:</strong> This information
                        will be shared with the Super Admin, Senior Counselor,
                        and Counselor.
                      </p>
                      <p>
                        <strong>⚠️ Important:</strong> Please ensure you toggle
                        this only when necessary.
                      </p>
                    </div>
                  </div>
                </div>
              }
            >
              <Flex align="center" gap={4} className="redflag-trigger">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.003 16H12.011M12.003 9.99997V13M10.578 5.21697L3.51998 17C3.37456 17.252 3.29765 17.5377 3.29688 17.8287C3.29612 18.1197 3.37153 18.4058 3.51562 18.6586C3.65972 18.9114 3.86747 19.1221 4.11823 19.2697C4.36899 19.4173 4.65402 19.4967 4.94498 19.5H19.061C19.3521 19.497 19.6373 19.4178 19.8882 19.2702C20.1391 19.1227 20.347 18.912 20.4912 18.6591C20.6353 18.4062 20.7107 18.1199 20.7098 17.8288C20.7089 17.5377 20.6317 17.252 20.486 17L13.429 5.21697C13.2805 4.9719 13.0714 4.76925 12.8218 4.6286C12.5722 4.48796 12.2905 4.41406 12.004 4.41406C11.7175 4.41406 11.4358 4.48796 11.1862 4.6286C10.9365 4.76925 10.7274 4.9719 10.579 5.21697"
                    stroke="#F87A36"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <Text className="redFlag">Redflag</Text>
                <Switch
                  size="small"
                  className="redFlagSwitch"
                  checked={redFlagChecked}
                  onChange={(checked) => {
                    setRedFlagChecked(checked);
                    if (checked) {
                      setRedflagModal(true);
                    } else {
                      setRedflagModal(false);
                    }
                  }}
                />
              </Flex>
            </Tooltip>
          </div>
          <Button
            onClick={() => setUserDetailsModal(true)}
            iconPosition="end"
            className="btn_light_blue"
            icon={
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_167_721)">
                  <path
                    d="M16.7031 6.5H16.6181V7.5H16.7031C16.8357 7.5 16.9629 7.55268 17.0567 7.64645C17.1504 7.74021 17.2031 7.86739 17.2031 8V18C17.2031 18.1326 17.1504 18.2598 17.0567 18.3536C16.9629 18.4473 16.8357 18.5 16.7031 18.5H7.70312C7.57052 18.5 7.44334 18.4473 7.34957 18.3536C7.2558 18.2598 7.20312 18.1326 7.20312 18V8C7.20312 7.86739 7.2558 7.74021 7.34957 7.64645C7.44334 7.55268 7.57052 7.5 7.70312 7.5H7.78813V6.5H7.70312C7.3053 6.5 6.92377 6.65804 6.64246 6.93934C6.36116 7.22064 6.20313 7.60218 6.20312 8V18C6.20312 18.3978 6.36116 18.7794 6.64246 19.0607C6.92377 19.342 7.3053 19.5 7.70312 19.5H16.7031C17.1009 19.5 17.4825 19.342 17.7638 19.0607C18.0451 18.7794 18.2031 18.3978 18.2031 18V8C18.2031 7.60218 18.0451 7.22064 17.7638 6.93934C17.4825 6.65804 17.1009 6.5 16.7031 6.5Z"
                    fill="#2E3191"
                    stroke="#2E3191"
                    strokeWidth="0.3"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.7031 5.5H14.2031V4H10.2031V5.5H8.70312V8.5H15.7031V5.5ZM14.7031 7.5H9.70312V6.5H11.2031V5H13.2031V6.5H14.7031V7.5Z"
                    fill="#2E3191"
                    stroke="#2E3191"
                    strokeWidth="0.3"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.20312 10.5H15.2031V11.5H9.20312V10.5ZM9.20312 13H15.2031V14H9.20312V13ZM9.20312 15.5H15.2031V16.5H9.20312V15.5Z"
                    fill="#2E3191"
                    stroke="#2E3191"
                    strokeWidth="0.3"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_167_721">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(4.20312 4)"
                    />
                  </clipPath>
                </defs>
              </svg>
            }
          >
            User Details
          </Button>
          <Input.Search
            className="searchField"
            placeholder="Search here..."
            onSearch={(value) => {
              setSearchText(value);
            }}
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
          />
        </div>
      </div>
      <AppTable
        loading={sessionLoading}
        dataSource={filteredData}
        columns={columns}
      />
      {/* Render the modal for the current tab */}
      {activeTab === "session_report" && (
        <SessionReportModal sessionData={sessionData?.data} />
      )}
      {activeTab === "therapy_goals" && <GoalsInTheraphyModal />}
      {activeTab === "session_notes" && <SessionNotesModal />}
      {<AmberModal />}
      {activeTab === "takeaway_resource" && (
        <>
          <ConselorTakeAway />
          <SeniorconselorTakeAway />
        </>
      )}
      <UserDetailsModal />
      <RedflagModal />
      <AmberModalTable />
    </Flex>
  );
}

export default React.memo(TabsTableInner);
